<template>
  <div class="renewal-input">
    <label :class="{'renewal-input__error': hasErrors }" for="id">{{ label }}</label>
    <input
      :class="{'renewal-input__error': hasErrors }"
      ref="input"
      :id="id"
      :name="name"
      v-bind="$attrs"
      v-mask="config"
      v-model="currentValue"
      :placeholder="placeholder"
      :type="type"
      @input="refresh($event.target.value)"
    />
    <span v-if="hasErrors" class="renewal-input__error-message">{{ errorMessage }}</span>
  </div>
</template>
<script>
import mask from '@/assets/masker/masker.directive'
import masker from '@/assets/masker/masker'
import tokens from '@/assets/masker/tokens'

export default {
  name: 'renewalSearch',
  directives: { mask },
  props: {
    value: {},  // eslint-disable-line
    label: {
      type: String,
      default: () => null
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'input'
    },
    type: {
      type: String,
      default: 'text'
    },
    errorMessage: {
      type: String,
      default: 'text'
    },
    errorCondition: {
      type: Boolean,
      default: false
    },
    mask: {
      type: [ String, Array ],
      required: false,
      default () {
        return 'N'.repeat(240)
      }
    },
    masked: {
      type: Boolean,
      default: false
    },
    tokens: {
      type: Object,
      default: () => tokens
    }
  },
  data () {
    return {
      currentValue: null,
      lastValue: null,
      status: '',
      timeout: null,
      hasErrors: false
    }
  },
  computed: {
    config () {
      return {
        mask: this.mask,
        masked: this.masked,
        tokens: this.tokens
      }
    }
  },
  watch: {
    value (newValue) {
      if (newValue !== this.lastValue) {
        this.refresh(newValue)
      }
    },
    masked () {
      this.refresh(this.currentValue)
    }
  },
  methods: {
    refresh (value) {
      this.currentValue = value
      const refreshValue = masker(value, this.mask, this.masked, this.tokens)
      if (refreshValue !== this.lastValue) {
        this.validator()
        this.lastValue = refreshValue
        this.$emit('input', refreshValue)
      }
    },
    async validator () {
      this.hasErrors = false
      this.status = 'typing'
      clearTimeout(this.timeout)
      this.timeout = this.invalidTimeout()
    },
    invalidTimeout () {
      return setTimeout(() => {
      this.hasErrors = this.errorCondition
      this.status = this.errorCondition ? 'invalid' : 'valid'
      }, 1000)
    }
  }
}
</script>
<style lang='scss' scoped>
.renewal-input {
  margin: 0;
  label {
    font: bold 16px Oscine;
    margin: 0 5px 0 1px ;
    color: #595959;
  }
  input {
    width: 100%;
    font: 500 16px Rubik;
    display: block;
    background-color: #ffffff;
    border: 1px solid #bdc2c6;
    border-radius: 8px;
    color: #444444;
    outline: 0;
    padding: 8px 16px;
  }
  &__error {
    color: #ff3b30 !important;
    border-color: #ff3b30 !important;
  }
  &__error-message {
    color: #ff3b30;
    font-family: Rubik;
    font-size: 12px;
    font-weight: 500;
    &:before {
      content: url(~@/assets/svg/icon-blocked.svg);
      position: relative;
      top: 2px;
      margin-right: 4px;
    }
  }
}
</style>
